import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Container,
  DialogActions,
  Dialog,
  Snackbar, 
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import 'material-icons/iconfont/material-icons.css';
import { branchpartyList, freightCreate, issueListbyVehilce } from "../../../Services/Services";
import { Checkbox, FormControlLabel } from '@mui/material';

export default function FreightEntryForm() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen1, setDialogOpen1] = useState(false);
  const [showAppPaymentFields, setShowAppPaymentFields] = useState(false);
  const [truckNumberInput, setTruckNumberInput] = useState("");
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [open, setOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({ phone_no: "" });
  const [showTdsWarning, setShowTdsWarning] = useState(false);
  const [tdsWarningMessage, setTdsWarningMessage] = useState("");
  
  const [formData, setFormData] = useState({
    party_id: "",
    branch_id: "",
    loading_date: "",
    unloading_date: "",
    truck_no: "",
    do_no: "",
    tp_no: "",
    from_location: "",
    to_location: "",
    loading_wt: "",
    received_wt: "",
    shortage_wt: "",
    billing_wt: "",
    freight_rate: "",
    freight_amt: "",
    tds_per: "",
    tds_amt: "",
    shortage_rate: "",
    shortage_amt: "",
    ad_mines_exp: "",
    ad_diesel_exp: "",
    ad_cash_exp: "",
    total_advance: "",
    commission: "",
    net_amount: "",
    other_exp: "",
    net_payable: "",
    truck_owner: "",
    phone_no: "",
    pan_no: "",
    payment_firm: "",
    received_firm: "",
    name_ac_no: "",
    remark: "",
    cheque_upi_no: "",
    pay_mode: "",
    pay_amount: "",
    payment_to: "",
    description: "",
    is_remember: false,
    is_not_rec: false,
  });

  const continueButton = () => {
    setDialogOpen(false);
    setDialogOpen1(false);
    setShowTdsWarning(false);
    setTdsWarningMessage("");
    setFormData({
      party_id: "",
      branch_id: "",
      loading_date: "",
      unloading_date: "",
      truck_no: "",
      do_no: "",
      tp_no: "",
      from_location: "",
      to_location: "",
      loading_wt: "",
      received_wt: "",
      shortage_wt: "",
      billing_wt: "",
      freight_rate: "",
      freight_amt: "",
      tds_per: "",
      tds_amt: "",
      shortage_rate: "",
      shortage_amt: "",
      ad_mines_exp: "",
      ad_diesel_exp: "",
      ad_cash_exp: "",
      total_advance: "",
      commission: "",
      net_amount: "",
      other_exp: "",
      net_payable: "",
      truck_owner: "",
      phone_no: "",
      pan_no: "",
      payment_firm: "",
      received_firm: "",
      name_ac_no: "",
      remark: "",
      cheque_upi_no: "",
      pay_mode: "",
      pay_amount: "",
      payment_to: "",
      is_remember: false,
      description: "",
      is_not_rec: false,
    });
  }
  
  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setFormData((prev) => ({
      ...prev,
      is_remember: checked,
    }));
  };
  
  const handleCheckboxChangeRec = (event) => {
    const checked = event.target.checked;
    setFormData((prev) => ({
      ...prev,
      is_not_rec: checked,
    }));
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = {
      ...formData,
      [name]: value,
    };

    const loading =
      parseFloat(
        name === "loading_wt" ? value : updatedData.loading_wt
      ) || 0;
    const receiving =
      parseFloat(
        name === "received_wt" ? value : updatedData.received_wt
      ) || 0;
    const freightRate =
      parseFloat(name === "freight_rate" ? value : updatedData.freight_rate) ||
      0;
    const tdsRate =
      parseFloat(name === "tds_per" ? value : updatedData.tds_per) || 0;
    const shortageRate =
      parseFloat(name === "shortage_rate" ? value : formData.shortage_rate) ||
      0;
    const commission =
      parseFloat(name === "commission" ? value : formData.commission) || 0;
    const minesAdvance =
      parseFloat(name === "ad_mines_exp" ? value : formData.ad_mines_exp) || 0;
    const dieselAdvance =
      parseFloat(name === "ad_diesel_exp" ? value : formData.ad_diesel_exp) ||
      0;
    const cashAdvance =
      parseFloat(name === "ad_cash_exp" ? value : formData.ad_cash_exp) || 0;

    //billng wt
    updatedData.billing_wt = Math.min(loading, receiving)
      .toFixed(2)
      .toString();
    //shortage wt
    const shortage = (loading - receiving) * 1000;
    updatedData.shortage_wt =
      shortage > 0 ? shortage.toFixed(2).toString() : "0";
    //Freight amt
    const billing = parseFloat(updatedData.billing_wt) || 0;
    updatedData.freight_amt = (freightRate * billing).toFixed(2).toString();
    //TDS amt
    const tdsAmt = (updatedData.freight_amt * tdsRate) / 100;
    updatedData.tds_amt = tdsAmt.toFixed(2).toString();
    //Shortage amt
    updatedData.shortage_amt = (
      parseFloat(updatedData.shortage_wt) * shortageRate
    )
      .toFixed(2)
      .toString();
    //Net Total Advance
    updatedData.total_advance = (minesAdvance + dieselAdvance + cashAdvance).toFixed(2).toString();

    updatedData.net_amount = (
      updatedData.freight_amt -
      updatedData.tds_amt -
      updatedData.shortage_amt -
      updatedData.total_advance -
      commission
    )
      .toFixed(2)
      .toString();
    updatedData.net_payable = (updatedData.net_amount - updatedData.other_exp)
      .toFixed(2)
      .toString();
    setFormData(updatedData);

    if (name === "phone_no") {
      const cleaned = value.replace(/\D/g, ""); // removes all non-digit characters

      if (cleaned.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: cleaned }));

        if (cleaned === "") {
          setFormErrors((prev) => ({ ...prev, [name]: "" }));
        } else if (cleaned.length !== 10) {
          setFormErrors((prev) => ({
            ...prev,
            [name]: "Phone number must be 10 digits",
          }));
        } else {
          setFormErrors((prev) => ({ ...prev, [name]: "" }));
        }
      }
      return;
    } else if (name === "pan_no") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

      setFormData((prev) => ({ ...prev, [name]: value.toUpperCase() })); // Uppercase force kar diya

      if (value === "") {
        setFormErrors((prev) => ({ ...prev, [name]: "" }));
      } else if (!panRegex.test(value.toUpperCase())) {
        setFormErrors((prev) => ({
          ...prev,
          [name]: " Format (e.g. ABCDE1234F)",
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.pay_amount > 0) {
        formData['bal_amount'] = (formData.net_payable - formData.pay_amount).toFixed(2);
        formData['paid_amount'] = formData.pay_amount;
        formData['is_invoice'] = true
        if (formData['bal_amount'] <= 0) {
          formData['is_completed'] = true;
        }
      } else {
        formData['bal_amount'] = formData.net_payable;
      }
      formData['resubmit'] = false;
      const response = await freightCreate(formData);
      if (response.message == 'done') {
        setMessage("Freight submitted successfully!");
        setError(""); // clear previous errors if any
        setFormData({
          party_id: "",
          branch_id: "",
          loading_date: "",
          unloading_date: "",
          truck_no: "",
          do_no: "",
          tp_no: "",
          from_location: "",
          to_location: "",
          loading_wt: "",
          received_wt: "",
          shortage_wt: "",
          billing_wt: "",
          freight_rate: "",
          freight_amt: "",
          tds_per: "",
          tds_amt: "",
          shortage_rate: "",
          shortage_amt: "",
          ad_mines_exp: "",
          ad_diesel_exp: "",
          ad_cash_exp: "",
          total_advance: "",
          commission: "",
          net_amount: "",
          other_exp: "",
          net_payable: "",
          truck_owner: "",
          phone_no: "",
          pan_no: "",
          remark: "",
          cheque_upi_no: "",
          pay_mode: "",
          pay_amount: "",
          payment_to: "",
          is_remember: false,
          description: "",
          is_not_rec: false,
        });
      }
      else if (response.message == 'already exists') {
        setDialogOpen1(true);
        setFreightOptions1([response.existing_freight]);
      }
      else {
        setError("Submission failed. Please check the data.");
        setMessage(""); // clear success message if any
      }
    } catch (err) {
      setError("An error occurred while submitting.");
      setMessage(""); // clear success message if any
    } finally {
      setOpen(true); // opens a modal/snackbar/dialog?
    }
  };

  const handleReSubmit = async () => {
    try {
      if (formData.pay_amount > 0) {
        formData['bal_amount'] = (formData.net_payable - formData.pay_amount).toFixed(2);
        formData['paid_amount'] = formData.pay_amount;
        formData['is_invoice'] = true
        if (formData['bal_amount'] <= 0) {
          formData['is_completed'] = true;
        }
      } else {
        formData['bal_amount'] = formData.net_payable;
      }
      formData['resubmit'] = true;
      const response = await freightCreate(formData);
      if (response.message == 'done') {
        setDialogOpen1(false);
        setMessage("Freight submitted successfully!");
        setError(""); // clear previous errors if any
        setFormData({
          party_id: "",
          branch_id: "",
          loading_date: "",
          unloading_date: "",
          truck_no: "",
          do_no: "",
          tp_no: "",
          from_location: "",
          to_location: "",
          loading_wt: "",
          received_wt: "",
          shortage_wt: "",
          billing_wt: "",
          freight_rate: "",
          freight_amt: "",
          tds_per: "",
          tds_amt: "",
          shortage_rate: "",
          shortage_amt: "",
          ad_mines_exp: "",
          ad_diesel_exp: "",
          ad_cash_exp: "",
          total_advance: "",
          commission: "",
          net_amount: "",
          other_exp: "",
          net_payable: "",
          truck_owner: "",
          phone_no: "",
          pan_no: "",
          remark: "",
          cheque_upi_no: "",
          pay_mode: "",
          pay_amount: "",
          payment_to: "",
          is_remember: false,
          is_not_rec: false,
          description: "",
        });
      }
      else if (response.message == 'already exists') {
        setDialogOpen1(true);
        setFreightOptions1([response.existing_freight]);
      }
      else {
        setError("Submission failed. Please check the data.");
        setMessage(""); // clear success message if any
      }
    } catch (err) {
      setError("An error occurred while submitting.");
      setMessage(""); // clear success message if any
    } finally {
      setOpen(true); // opens a modal/snackbar/dialog?
    }
  };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }

  const [partyOptions, setParties] = useState([]);
  const [branchOptions, setBranch] = useState([]);
  const [paymentIssue, setPaymentIssue] = useState([]);
  
  useEffect(() => {
    const fetchBranchParties = async () => {
      const data = await branchpartyList();
      if (data) {
        setParties(data.party);
        setBranch(data.branch);
      }
    }
    fetchBranchParties();
  }, []);

  const [freightOptions, setFreightOptions] = useState([]);
  const [freightOptions1, setFreightOptions1] = useState([]);
  
  const checkTrukIssue = async () => {
    if (!truckNumberInput) return;

    const data = await issueListbyVehilce(truckNumberInput);

    // Check if valid structured response
    if (data && typeof data === "object") {
      // Set truck info if available
      setFormData((prev) => ({
        ...prev,
        truck_owner: data.truck_info?.truck_owner || "",
        phone_no: data.truck_info?.phone_no || "",
        pan_no: data.truck_info?.pan_no || "",
      }));

      // TDS declaration check
      if (data.tds_declaration_exists === false) {
        setTdsWarningMessage(
          `TDS declaration for truck ${truckNumberInput} for current year not available.`
        );
        setShowTdsWarning(true);
      } else {
        setShowTdsWarning(false);
        setTdsWarningMessage("");
      }

      // Set issue list and open dialog if issues exist
      if (Array.isArray(data.issues) && data.issues.length > 0) {
        setFreightOptions(data.issues);
        setDialogOpen(true);
      } else {
        setFreightOptions([]);
      }

      // Optionally, handle payments if needed
      if (Array.isArray(data.payments) && data.payments.length > 0) {
        setPaymentIssue(data.payments);
        setDialogOpen(true);
      } else {
        setPaymentIssue([]);
      }

      // If TDS warning exists but no issues/payments, still show dialog
      if (data.tds_declaration_exists === false && 
          (!Array.isArray(data.issues) || data.issues.length === 0) && 
          (!Array.isArray(data.payments) || data.payments.length === 0)) {
        setDialogOpen(true);
      }
    } else {
      // Fallback if data is not valid
      setFormData((prev) => ({
        ...prev,
        truck_owner: "",
        phone_no: "",
        pan_no: "",
      }));
      setShowTdsWarning(false);
      setTdsWarningMessage("");
    }
  };

  const handlePaymentchange = () => {
    setShowAppPaymentFields(!showAppPaymentFields)
    if (showAppPaymentFields) {
      setFormData((prev) => ({
        ...prev,
        pay_amount: "",
        payment_to: "",
        pay_mode: "",
        upi_check_no: "",
        paid_amount: ""
      }));
    }
  }
  
  return (
    <Container>
      <form onSubmit={handleSubmit}
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.is_remember}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Remember"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.is_not_rec}
                    onChange={handleCheckboxChangeRec}
                  />
                }
                label="Freight Not Received"
              />
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={handlePaymentchange}
                sx={{ mr: 2 }}
              >
                {showAppPaymentFields ? (
                  <>
                    <span className="material-icons">close</span> Payment
                  </>
                ) : (
                  <>
                    <span className="material-icons">add</span> Payment
                  </>
                )}
              </Button>

              <Button variant="contained" color="primary" type="submit">
                Add Freight
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Autocomplete
              options={partyOptions}
              getOptionLabel={(option) => option?.name || ""}
              value={
                partyOptions.find((b) => b.party_id === formData.party_id) ||
                null
              }
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  party_id: newValue?.party_id || "",
                  commission: newValue?.commission || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Party Name"
                  variant="outlined"
                  size="medium"
                  required
                  sx={{ "& .MuiInputBase-root": { height: "45px" } }}
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Autocomplete
              options={branchOptions}
              getOptionLabel={(option) => option?.branch_name || ""}
              value={
                branchOptions.find((b) => b.branch_id === formData.branch_id) ||
                null
              }
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  branch_id: newValue?.branch_id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Branch Name"
                  variant="outlined"
                  size="medium"
                  required
                  sx={{ "& .MuiInputBase-root": { height: "45px" } }}
                />
              )}
            />
          </Grid>

          {/* row 2*/}
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="From"
              name="from_location"
              value={formData.from_location}
              onChange={handleChange}
              required
              autoComplete="on"
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="To"
              name="to_location"
              value={formData.to_location}
              onChange={handleChange}
              required
              autoComplete="on"
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Loading Date"
              type="date"
              name="loading_date"
              value={formData.loading_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Unloading Date"
              type="date"
              name="unloading_date"
              value={formData.unloading_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <TextField
              label="Truck No."
              name="truck_no"
              value={formData.truck_no}
              onChange={(e) => {
                handleChange(e);
                setTruckNumberInput(e.target.value);
              }}
              onBlur={(e) => {
                if (e.target.value.trim() !== "") {
                  checkTrukIssue();
                }
              }}
              fullWidth
              required
              autoComplete="on"
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="D.O. NO."
              name="do_no"
              value={formData.do_no}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="T.P. NO."
              name="tp_no"
              value={formData.tp_no}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Loading Wt"
              type="number"
              name="loading_wt"
              value={formData.loading_wt}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Receiving Wt"
              type="number"
              name="received_wt"
              value={formData.received_wt}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Shortage Wt"
              type="number"
              name="shortage_wt"
              value={formData.shortage_wt}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Billing Wt"
              type="number"
              name="billing_wt"
              value={formData.billing_wt}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>

          {/* Row 5 */}
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Freight Rate"
              type="number"
              name="freight_rate"
              value={formData.freight_rate}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Freight AMT"
              type="number"
              name="freight_amt"
              value={formData.freight_amt}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="TDS (%)"
              type="number"
              name="tds_per"
              value={formData.tds_per}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="TDS AMT"
              type="number"
              name="tds_amt"
              value={formData.tds_amt}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Shortage Rate"
              type="number"
              name="shortage_rate"
              value={formData.shortage_rate}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Shortage AMT"
              type="number"
              name="shortage_amt"
              value={formData.shortage_amt}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Advance Mines"
              type="number"
              name="ad_mines_exp"
              value={formData.ad_mines_exp}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Advance Diesel"
              type="number"
              name="ad_diesel_exp"
              value={formData.ad_diesel_exp}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Advance Cash"
              type="number"
              name="ad_cash_exp"
              value={formData.ad_cash_exp}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Total Advance"
              type="number"
              name="total_advance"
              value={formData.total_advance}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          {/* Row 6 */}
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Munsiyana"
              type="number"
              name="commission"
              value={formData.commission}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Net AMT"
              type="number"
              name="net_amount"
              value={formData.net_amount}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Other Exp."
              type="number"
              name="other_exp"
              value={formData.other_exp}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Net Payable"
              type="number"
              name="net_payable"
              value={formData.net_payable}
              onChange={handleChange}
              disabled
              required
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Truck Owner"
              name="truck_owner"
              value={formData.truck_owner}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="Phone No."
              name="phone_no"
              value={formData.phone_no}
              onChange={handleChange}
              error={!!formErrors.phone_no}
              helperText={formErrors.phone_no || " "}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
                pattern: "\\d*",
              }}
            />
          </Grid>

          <Grid item xs={2.4}>
            <TextField
              fullWidth
              label="PAN No."
              name="pan_no"
              value={formData.pan_no}
              onChange={handleChange}
              inputProps={{ maxLength: 10 }}
              error={!!formErrors.pan_no}
              helperText={formErrors.pan_no || " "}
            />
          </Grid>

          <Grid item xs={4.8}>
            <TextField
              fullWidth
              label="Remark"
              name="remark"
              value={formData.remark}
              onChange={handleChange}
            />
          </Grid>

          {showAppPaymentFields && (
            <>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  name="pay_amount"
                  label="Pay Amount"
                  type="number"
                  value={formData.pay_amount}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  name="payment_to"
                  label="Payment To"
                  value={formData.payment_to}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  name="pay_mode"
                  label="Payment Mode"
                  value={formData.pay_mode}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  name="upi_check_no"
                  label="UPI / Cheque No."
                  value={formData.upi_check_no}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="description"
                  label="Payment Description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}
        </Grid>
      </form>
      
      {/* Main Dialog for Issues, Payments and TDS Warning */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        fullWidth
        maxWidth={false}
        PaperProps={{
          style: {
            width: '90%',
            margin: 0,
            maxWidth: '90%',
            top: 0,
          },
        }}
      >
        {/* TDS Warning Section */}
        {showTdsWarning && (
          <div style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            padding: '15px',
            margin: '10px',
            borderRadius: '5px',
            textAlign: 'center'
          }}>
            <h4 style={{ color: '#856404', margin: 0 }}>
              <span className="material-icons" style={{ 
                verticalAlign: 'middle',
                marginRight: '8px',
                color: '#856404'
              }}>warning</span>
              {tdsWarningMessage}
            </h4>
          </div>
        )}

        {/* Issues Section */}
        {freightOptions.length > 0 &&
          <>
            <h4 style={{ textAlign: "center" }}>CHECK IN TRUCK NO ANY ISSUE CREATED</h4>
            <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
              <div style={{ overflowX: "auto" }}>
                <Table
                  size="small"
                  id="freight-list"
                  sx={{
                    tableLayout: "auto",
                    width: "auto",
                    "& td, & th": {
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      padding: "4px 8px",
                      fontSize: "0.8125rem",
                      borderBottom: "1px solid #ccc",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          fontWeight: "bold",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "#2196f3" : "#333",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                        },
                      }}
                    >
                      <TableCell>SR. No</TableCell>
                      <TableCell>Freight Id</TableCell>
                      <TableCell>Party Name</TableCell>
                      <TableCell>Branch Name</TableCell>
                      <TableCell>Loading Date</TableCell>
                      <TableCell>Unloading Date</TableCell>
                      <TableCell>Truck No.</TableCell>
                      <TableCell>D.O. No.</TableCell>
                      <TableCell>T.P. No.</TableCell>
                      <TableCell>From</TableCell>
                      <TableCell>To</TableCell>
                      <TableCell>Loading Wt</TableCell>
                      <TableCell>Receiving Wt</TableCell>
                      <TableCell>Shortage Wt</TableCell>
                      <TableCell>Billing Wt</TableCell>
                      <TableCell>Freight Rate</TableCell>
                      <TableCell>Freight Amt</TableCell>
                      <TableCell>TDS %</TableCell>
                      <TableCell>TDS Amt</TableCell>
                      <TableCell>Shortage Rate</TableCell>
                      <TableCell>Shortage Amt</TableCell>
                      <TableCell>Ad Mines</TableCell>
                      <TableCell>Ad Diesel</TableCell>
                      <TableCell>Ad Cash</TableCell>
                      <TableCell>Total Ad</TableCell>
                      <TableCell>Commission</TableCell>
                      <TableCell>Net Amt</TableCell>
                      <TableCell>Others Exp.</TableCell>
                      <TableCell>Net Payable</TableCell>
                      <TableCell>Truck Owner</TableCell>
                      <TableCell>Phone No.</TableCell>
                      <TableCell>PAN No.</TableCell>
                      <TableCell>Remark</TableCell>
                      <TableCell>Description</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {freightOptions.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={32} align="center">
                          No matching records found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      freightOptions.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                            "& td": {
                              color: (theme) =>
                                theme.palette.mode === "dark" ? "white" : "inherit",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark" ? "black" : "inherit",
                            },
                          }}
                        >
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.freight_id.freight_id}</TableCell>
                          <TableCell>{row.party_name}</TableCell>
                          <TableCell>{row.branch_name}</TableCell>
                          <TableCell>{row.freight_id.loading_date}</TableCell>
                          <TableCell>{row.freight_id.unloading_date}</TableCell>
                          <TableCell>{row.freight_id.truck_no}</TableCell>
                          <TableCell>{row.freight_id.do_no}</TableCell>
                          <TableCell>{row.freight_id.tp_no}</TableCell>
                          <TableCell>{row.freight_id.from_location}</TableCell>
                          <TableCell>{row.freight_id.to_location}</TableCell>
                          <TableCell>{row.freight_id.loading_wt}</TableCell>
                          <TableCell>{row.freight_id.received_wt}</TableCell>
                          <TableCell>{row.freight_id.shortage_wt}</TableCell>
                          <TableCell>{row.freight_id.billing_wt}</TableCell>
                          <TableCell>{row.freight_id.freight_rate}</TableCell>
                          <TableCell>{row.freight_id.freight_amt}</TableCell>
                          <TableCell>{row.freight_id.tds_per}</TableCell>
                          <TableCell>{row.freight_id.tds_amt}</TableCell>
                          <TableCell>{row.freight_id.shortage_rate}</TableCell>
                          <TableCell>{row.freight_id.shortage_amt}</TableCell>
                          <TableCell>{row.freight_id.ad_mines_exp}</TableCell>
                          <TableCell>{row.freight_id.ad_diesel_exp}</TableCell>
                          <TableCell>{row.freight_id.ad_cash_exp}</TableCell>
                          <TableCell>{row.freight_id.total_advance}</TableCell>
                          <TableCell>{row.freight_id.commission}</TableCell>
                          <TableCell>{row.freight_id.net_amount}</TableCell>
                          <TableCell>{row.freight_id.other_exp}</TableCell>
                          <TableCell>{row.freight_id.net_payable}</TableCell>
                          <TableCell>{row.freight_id.truck_owner}</TableCell>
                          <TableCell>{row.freight_id.phone_no}</TableCell>
                          <TableCell>{row.freight_id.pan_no}</TableCell>
                          <TableCell>{row.freight_id.remark}</TableCell>
                          <TableCell>{row.description}</TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>
          </>
        }
        
        {/* Payments Section */}
        {paymentIssue.length > 0 &&
          <>
            <h4 style={{ textAlign: "center" }}>CHECK IN TRUCK NO ANY EXTRA PAYMENT CREATED</h4>
            <TableContainer sx={{ width: "100%" }}>
              <Table
                size="small"
                id="freight-payment"
                sx={{
                  minWidth: "100%",
                  tableLayout: "auto",
                  "& td, & th": {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    padding: "0px 8px",
                    fontSize: "0.8125rem",
                    borderBottom: "1px solid #ccc",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        fontWeight: "bold",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "#2196f3" : "#333",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                      },
                    }}
                  >
                    <TableCell>Sr No.</TableCell>
                    <TableCell>Pay Id</TableCell>
                    <TableCell>Branch</TableCell>
                    <TableCell>Freight ID</TableCell>
                    <TableCell>Total Amt</TableCell>
                    <TableCell>Paid Amt</TableCell>
                    <TableCell>Rem Amount</TableCell>
                    <TableCell>Pay Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentIssue.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "& td": {
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.freight_payment_id}</TableCell>
                      <TableCell>{row.branch_name}</TableCell>
                      <TableCell>{Array.isArray(row.freight_id) ? row.freight_id.join(', ') : row.freight_id}</TableCell>
                      <TableCell>{(row.total_amount).toFixed(2)}</TableCell>
                      <TableCell>{(row.paid_amount).toFixed(2)}</TableCell>
                      <TableCell>{(row.rem_amount).toFixed(2)}</TableCell>
                      <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        }
        
        {/* Show message when only TDS warning exists */}
        {showTdsWarning && freightOptions.length === 0 && paymentIssue.length === 0 && (
          <div style={{ textAlign: "center", padding: "30px" }}>
            <span className="material-icons" style={{ 
              fontSize: '60px',
              color: '#ff9800',
              marginBottom: '15px'
            }}>warning</span>
            <h3>TDS Declaration Missing</h3>
            <p style={{ fontSize: "16px", color: "#666", marginBottom: "20px" }}>
              {tdsWarningMessage}
            </p>
            <p style={{ color: '#999', fontStyle: 'italic' }}>
              No issues or payments found for this truck.
            </p>
          </div>
        )}
        
        <DialogActions>
          <Button
            onClick={() => setDialogOpen(false)}
            style={{ backgroundColor: 'blue', color: 'white' }}
          >
            Continue
          </Button>

          <Button
            onClick={() => continueButton()}
            style={{ backgroundColor: 'red', color: 'white' }}
          >
            Stop
          </Button>

          {/* <Button
            style={{ backgroundColor: 'green', color: 'white' }}
          >
            <a href="/dashboard/issue-list" style={{ textDecoration: 'none', color: 'white' }}>
              Resolve
            </a>
          </Button> */}
        </DialogActions>
      </Dialog>
      
      {/* Duplicate Freight Dialog */}
      <Dialog
        open={dialogOpen1}
        onClose={() => setDialogOpen1(false)}
        fullWidth
        maxWidth={false}
        PaperProps={{
          style: {
            width: '90%',
            margin: 0,
            maxWidth: '90%',
            top: 0,
          },
        }}
      >
        <h4 style={{ textAlign: "center" }}>DUPLICATE FREIGHT BY CHECKING LOADING DATE AND TRUCK NO.</h4>
        <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
          <div style={{ overflowX: "auto" }}>
            <Table
              size="small"
              id="freight-list"
              sx={{
                tableLayout: "auto",
                width: "auto",
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  padding: "4px 8px",
                  fontSize: "0.8125rem",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#2196f3" : "#333",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                    },
                  }}
                >
                  <TableCell>SR. No</TableCell>
                  <TableCell>Freight Id</TableCell>
                  <TableCell>Party Name</TableCell>
                  <TableCell>Branch Name</TableCell>
                  <TableCell>Loading Date</TableCell>
                  <TableCell>Unloading Date</TableCell>
                  <TableCell>Truck No.</TableCell>
                  <TableCell>D.O. No.</TableCell>
                  <TableCell>T.P. No.</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Loading Wt</TableCell>
                  <TableCell>Receiving Wt</TableCell>
                  <TableCell>Shortage Wt</TableCell>
                  <TableCell>Billing Wt</TableCell>
                  <TableCell>Freight Rate</TableCell>
                  <TableCell>Freight Amt</TableCell>
                  <TableCell>TDS %</TableCell>
                  <TableCell>TDS Amt</TableCell>
                  <TableCell>Shortage Rate</TableCell>
                  <TableCell>Shortage Amt</TableCell>
                  <TableCell>Ad Mines</TableCell>
                  <TableCell>Ad Diesel</TableCell>
                  <TableCell>Ad Cash</TableCell>
                  <TableCell>Total Ad</TableCell>
                  <TableCell>Commission</TableCell>
                  <TableCell>Net Amt</TableCell>
                  <TableCell>Others Exp.</TableCell>
                  <TableCell>Net Payable</TableCell>
                  <TableCell>Truck Owner</TableCell>
                  <TableCell>Phone No.</TableCell>
                  <TableCell>PAN No.</TableCell>
                  <TableCell>Remark</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {freightOptions1.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={32} align="center">
                      No matching records found.
                    </TableCell>
                  </TableRow>
                ) : (
                  freightOptions1.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "& td": {
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.freight_id}</TableCell>
                      <TableCell>{row.party_name}</TableCell>
                      <TableCell>{row.branch_name}</TableCell>
                      <TableCell>{row.loading_date}</TableCell>
                      <TableCell>{row.unloading_date}</TableCell>
                      <TableCell>{row.truck_no}</TableCell>
                      <TableCell>{row.do_no}</TableCell>
                      <TableCell>{row.tp_no}</TableCell>
                      <TableCell>{row.from_location}</TableCell>
                      <TableCell>{row.to_location}</TableCell>
                      <TableCell>{row.loading_wt}</TableCell>
                      <TableCell>{row.received_wt}</TableCell>
                      <TableCell>{row.shortage_wt}</TableCell>
                      <TableCell>{row.billing_wt}</TableCell>
                      <TableCell>{row.freight_rate}</TableCell>
                      <TableCell>{row.freight_amt}</TableCell>
                      <TableCell>{row.tds_per}</TableCell>
                      <TableCell>{row.tds_amt}</TableCell>
                      <TableCell>{row.shortage_rate}</TableCell>
                      <TableCell>{row.shortage_amt}</TableCell>
                      <TableCell>{row.ad_mines_exp}</TableCell>
                      <TableCell>{row.ad_diesel_exp}</TableCell>
                      <TableCell>{row.ad_cash_exp}</TableCell>
                      <TableCell>{row.total_advance}</TableCell>
                      <TableCell>{row.commission}</TableCell>
                      <TableCell>{row.net_amount}</TableCell>
                      <TableCell>{row.other_exp}</TableCell>
                      <TableCell>{row.net_payable}</TableCell>
                      <TableCell>{row.truck_owner}</TableCell>
                      <TableCell>{row.phone_no}</TableCell>
                      <TableCell>{row.pan_no}</TableCell>
                      <TableCell>{row.remark}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </TableContainer>
        <DialogActions>
          <Button
            onClick={handleReSubmit}
            style={{ backgroundColor: 'blue', color: 'white' }}
          >
            Continue
          </Button>

          <Button
            onClick={() => continueButton()}
            style={{ backgroundColor: 'red', color: 'white' }}
          >
            Stop
          </Button>
        </DialogActions>
      </Dialog>
      
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={error ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {error || message}
        </Alert>
      </Snackbar>
    </Container>
  );
}